export default {"src":"/_next/static/media/Redis.c1787966.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};